module.exports = __webpack_public_path__ + "img/300.green.dc4ceba1.gif";